import { TextField, TextFieldProps } from '@mui/material';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

type Props = {
  name: string;
  editMode?: boolean;
} & TextFieldProps;

const InputText = ({ editMode, ...props }: Props) => {
  const { values, handleChange, errors, touched, handleBlur } =
    useFormikContext<Record<string, unknown>>();

  const hasErrors = useMemo(() => {
    if (errors?.[props.name]) {
      return true;
    }
    return false;
  }, [errors, props.name]);

  const isTouched = useMemo(() => {
    if (touched?.[props.name]) {
      return true;
    }
    return false;
  }, [props.name, touched]);

  return (
    <TextField
      value={values?.[`${props.name}`] ?? ''}
      fullWidth={props.fullWidth ?? true}
      onChange={handleChange}
      onBlur={handleBlur}
      error={editMode ? hasErrors : hasErrors && isTouched}
      helperText={
        editMode
          ? hasErrors
          : hasErrors && isTouched
          ? (errors?.[props.name] as string)
          : undefined
      }
      {...props}
    />
  );
};

export default InputText;
